import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  brand: { si: "රන් රුවන් හදවත් ස්වාරාන්ජලිය", en: "Ran Ruwan Hadawath Swaranjaliya" },
  brand_sub: { si: "NEOX", en: "NEOX" },
  brand_tagline: { si: "සෑම හදවතක්ම රාජකීය විය හැකි තැන", en: "Where every heart can be royalty", ta: "ஒவ்வொரு இதயமும் அரசாக இருக்கும் இடம்" },
  admin: { si: "පාලක පුවරුව", en: "Admin" },
  hero_title: { si: "රන් රුවන් හදවත් ස්වාරාන්ජලිය", en: "Ran Ruwan Hadawath Swaranjaliya — Sacred Melodies of Sri Lanka" },
  hero_sub: { si: "පැරණි සිංහල ගීත, වීණා සහ තබ්ලා නද — සන්සුන් සවන්දීමකට නවාතැනක්.", en: "Calm old Sinhala songs, veena, and tabla. Music the way a temple lamp is lit." },
  play_all: { si: "සියල්ල වාදනය කරන්න", en: "Play all" },
  featured: { si: "අද දින විශේෂිත ගීත", en: "New songs today" },
  featured_sub: { si: "Featured songs today", en: "අද දින විශේෂිත ගීත" },
  full_list: { si: "සම්පූර්ණ ගීත එකතුව", en: "Full song collection" },
  full_list_sub: { si: "Full collection", en: "සම්පූර්ණ එකතුව" },
  no_songs: { si: "තවම ගීත එකතු කර නැත.", en: "No songs added yet." },
  loading: { si: "පූරණය වෙමින්...", en: "Loading..." },
  play: { si: "වාදනය කරන්න", en: "Play" },
  pause: { si: "නවත්වන්න", en: "Pause" },
  prev: { si: "පෙර ගීතය", en: "Previous song" },
  next: { si: "ලඟම ගීතය", en: "Next song" },
  ambient_play: { si: "සන්සුන් සංගීතය", en: "Calm music" },
  ambient_stop: { si: "සංගීතය නවත්වන්න", en: "Stop music" },
  music_credit_bg: { si: "පසුබිම් සංගීතය", en: "Background music" },
  music_credit_lic: { si: "CC BY 4.0 බලපත්‍රය යටතේ", en: "Licensed under CC BY 4.0" },
  invite_send: { si: "පවුලට හා යාළුවන්ට එවන්න", en: "Invite family & friends" },
  poets_corner: { si: "කවි කොන — ඔබේ කවි ලියන්න", en: "Poets' Corner — write your poem" },
  karaoke: { si: "කැරෝකේ කාමරේ — සාමාජිකයන්ට", en: "Karaoke Room — for members" },
  ideas_wall: { si: "ශ්‍රී ලංකාවට අදහස් — ඔබේ හඬ", en: "Ideas for Sri Lanka — your voice" },
  friends_wall: { si: "ශ්‍රී ලංකාවේ මිතුරෝ — ලෝකයෙන්", en: "Friends of Sri Lanka — from the world" },
  heritage_wall: { si: "ශ්‍රී ලංකාවේ ජීවමාන උරුමය", en: "Living Heritage of Sri Lanka" },
  poster_download: { si: "පෝස්ටරය බාගන්න", en: "Download poster" },
  invite_msg: { si: "🪔 Neox ස්වාරාන්ජලිය — අම්මට තාත්තට පැරණි සිංහල ගී, කතන්දර හා භාවනා. මනස නැවුම් කරන, ලොග් වීමක් නැහැ, නොමිලේ. මෙතනින් අහන්න:", en: "🪔 Neox Swaranjaliya — calm old songs, stories & meditation for our elders. Mind refreshing, no login, free. Listen here:" },
  sotd_save_img: { si: "පින්තූරය සුරකින්න", en: "Save image" },
  sotd_family_send: { si: "අද සින්දුව පවුලේ group එකට එවන්න", en: "Send today's song to my family group" },
  sotd_family_msg: { si: "🪔 පවුලේ හැමෝටම — අද Neox ස්වාරාන්ජලිය තෝරාගත් සින්දුව 🎶", en: "🪔 For the whole family — today's pick from Neox Swaranjaliya 🎶" },
  share_card_listen: { si: "neox.lk හි නොමිලේ අහන්න", en: "Listen free at neox.lk" },
  invite_page_tag: { si: "පැරණි සිංහල ගී · කතන්දර · භාවනා", en: "Calm old songs · Stories · Meditation" },
  invite_page_sub: { si: "ලොග් වීමක් නැහැ · නොමිලේ · ඕනෑම වේලාවක", en: "No login · Free · Anytime" },
  invite_listen_free: { si: "නොමිලේ අහන්න පටන් ගන්න", en: "Start listening free" },
  listeners_joined: { si: "දෙනෙක් දැනටමත් සවන්දී ඇත", en: "people are already listening" },
  sotd_title: { si: "අද ගීතය", en: "Song of the day" },
  sotd_greet: { si: "අද ඔබට කුඩා තෑග්ගක් 🌸", en: "Today's little gift for you 🌸" },
  sotd_g_morning: { si: "සුබ උදෑසනක්, යහළුවා/යෙහෙළිය 🌅", en: "Good morning, friend 🌅" },
  sotd_g_afternoon: { si: "සුබ දහවලක්, යහළුවා/යෙහෙළිය ☀️", en: "Good afternoon, friend ☀️" },
  sotd_g_evening: { si: "සුබ සන්ධ්‍යාවක්, යහළුවා/යෙහෙළිය 🌇", en: "Good evening, friend 🌇" },
  sotd_g_night: { si: "සුබ රාත්‍රියක්, යහළුවා/යෙහෙළිය 🌙", en: "Good night, friend 🌙" },
  auto_next: { si: "ලඟම ගීතය ඉබේම", en: "Auto-next" },
  tap_continue: { si: "දිගටම වාදනය කිරීමට මෙතන ඔබන්න", en: "Tap here to continue playing" },
  now_playing: { si: "දැන් වාදනය වෙමින්", en: "Now playing" },
  sleep: { si: "නින්ද ටයිමරය", en: "Sleep timer" },
  sleep_off: { si: "අක්‍රියයි", en: "Off" },
  sleep_end: { si: "මෙම ගීතය අවසානයේ", en: "End of song" },
  sleep_min: { si: "විනාඩි", en: "min" },
  sleep_on: { si: "නින්ද:", en: "Sleep:" },
  quiet_note: { si: "මනස නැවුම් කරන · ලුහුබැඳීම් නැත · සන්සුන් සවන්දීමක්", en: "Mind refreshing · No tracking · Quiet listening" },
  filters_all: { si: "සියල්ල", en: "All" },
  filters_calm: { si: "සන්සුන් ගී", en: "Calm classics" },
  filters_veena: { si: "වීණා නද", en: "Veena" },
  filters_tabla: { si: "තබ්ලා නද", en: "Tabla" },
  back_room: { si: "කාමරයට ආපසු", en: "Back to room" },
  // submit
  submit_nav: { si: "ඔබේ සිංදුව එවන්න", en: "Submit your song" },
  submit_title: { si: "ඔබේ පටිගත කිරීම බෙදාගන්න", en: "Share your recording" },
  submit_sub: { si: "නව ගායක ගායිකාවන්ට තම පටිගත කිරීම් අප වෙත එවිය හැක. පළමුව විද්‍යුත් තැපෑල තහවුරු කරන්න.", en: "New singers can send us their recordings. First verify your email with a one-time code." },
  submit_email_label: { si: "ඔබේ විද්‍යුත් තැපෑල", en: "Your email" },
  submit_send_code: { si: "කේතය එවන්න", en: "Send code" },
  submit_code_label: { si: "විද්‍යුත් තැපෑලට ලැබුණු කේතය ඇතුළත් කරන්න", en: "Enter the code we emailed you" },
  submit_verify: { si: "තහවුරු කරන්න", en: "Verify" },
  submit_resend: { si: "කේතය නැවත එවන්න", en: "Resend code" },
  submit_change_email: { si: "විද්‍යුත් තැපෑල වෙනස් කරන්න", en: "Change email" },
  submit_form_title: { si: "සිංදුවේ විස්තර", en: "Song details" },
  f_title_en: { si: "සිංදුවේ නම (ඉංග්‍රීසි)", en: "Song title (English)" },
  f_title_si: { si: "සිංදුවේ නම (සිංහල)", en: "Song title (Sinhala)" },
  f_artist: { si: "ගායක / ගායිකා", en: "Artist" },
  f_singer_name: { si: "ඔබේ නම", en: "Your name" },
  f_contact: { si: "දුරකථන / සම්බන්ධතා (විකල්ප)", en: "Phone / contact (optional)" },
  f_year: { si: "වර්ෂය (විකල්ප)", en: "Year (optional)" },
  f_tags: { si: "ටැග් (කොමාවෙන් වෙන් කරන්න)", en: "Tags (comma separated)" },
  f_notes: { si: "සටහන් (විකල්ප)", en: "Notes (optional)" },
  f_audio: { si: "ශ්‍රව්‍ය ගොනුව (MP3)", en: "Audio file (MP3)" },
  f_cover: { si: "කවරයේ පින්තූරය (විකල්ප)", en: "Cover image (optional)" },
  consent_label: { si: "මෙම පටිගත කිරීමේ අයිතිය මට ඇති බවත්, එය Neox ස්වාරාන්ජලිය හි බෙදාගැනීමට කැමැත්ත දෙන බවත් සහතික කරමි.", en: "I confirm I own the rights to this recording and consent to sharing it on Neox Swaranjaliya." },
  submit_btn: { si: "සිංදුව එවන්න", en: "Submit song" },
  submit_done_title: { si: "ස්තූතියි! ඔබේ සිංදුව ලැබුණි.", en: "Thank you! Your song was received." },
  submit_done_sub: { si: "අපගේ කණ්ඩායම එය සමාලෝචනය කර ඉක්මනින් එකතු කරයි.", en: "Our team will review it and add it to the room shortly." },
  submit_another: { si: "තවත් එකක් එවන්න", en: "Submit another" },
  // workshop
  ws_nav: { si: "නිර්මාණ වැඩමුළුව", en: "Creation Workshop" },
  ws_title: { si: "නිර්මාණ වැඩමුළුව", en: "Creation Workshop" },
  ws_sub: { si: "පදරචකයෝ පද ලියති · තනු නිර්මාණකරුවෝ තනු එකතු කරති · ගායකයෝ ගයති. වාණිජ නොවන ප්‍රජා බෙදාගැනීමක් පමණි.", en: "Lyricists post words · composers add melodies · singers record. Non-commercial community sharing only." },
  ws_post: { si: "පද පළ කරන්න", en: "Post lyrics" },
  ws_empty: { si: "තවම නිර්මාණ නැත. පළමුවැන්නා වන්න!", en: "No projects yet — be the first!" },
  ws_new_title: { si: "නව පද නිර්මාණයක්", en: "New lyrics project" },
  ws_field_title: { si: "මාතෘකාව", en: "Title" },
  ws_field_lyrics: { si: "පද", en: "Lyrics" },
  ws_field_author: { si: "ඔබේ නම", en: "Your name" },
  ws_field_tags: { si: "ටැග් (කොමාවෙන්)", en: "Tags (comma separated)" },
  ws_melodies: { si: "තනු", en: "Melodies" },
  ws_vocals: { si: "ගැයුම්", en: "Vocal takes" },
  ws_none_melody: { si: "තවම තනු නැත.", en: "No melodies yet." },
  ws_none_vocal: { si: "තවම ගැයුම් නැත.", en: "No vocal takes yet." },
  ws_add_melody: { si: "තනුවක් එකතු කරන්න", en: "Add a melody" },
  ws_sing: { si: "ගයන්න / පටිගත කරන්න", en: "Sing / Record" },
  ws_upload_take: { si: "සම්පූර්ණ ගැයුමක් උඩුගත කරන්න", en: "Upload a finished take" },
  ws_composer: { si: "තනු නිර්මාණකරුගේ නම", en: "Composer name" },
  ws_singer: { si: "ගායකයාගේ නම", en: "Singer name" },
  ws_instrumental: { si: "තනුව (වාද්‍ය ගොනුව)", en: "Melody (instrumental audio)" },
  ws_pick_melody: { si: "ගැයීමට තනුවක් තෝරන්න", en: "Choose a melody to sing over" },
  ws_record: { si: "පටිගත කිරීම අරඹන්න", en: "Start recording" },
  ws_stop: { si: "නවත්වන්න", en: "Stop" },
  ws_rerecord: { si: "නැවත පටිගත කරන්න", en: "Re-record" },
  ws_balance: { si: "හඬ / තනු තුලනය", en: "Voice / melody balance" },
  ws_mixing: { si: "මිශ්‍ර කරමින්...", en: "Mixing..." },
  ws_publish_take: { si: "ගැයුම පළ කරන්න", en: "Publish take" },
  ws_open: { si: "විවෘත කරන්න", en: "Open" },
  ws_by: { si: "විසින්", en: "by" },
  recording_now: { si: "පටිගත වෙමින්...", en: "Recording..." },
  mic_denied: { si: "මයික්‍රොෆෝනය භාවිතයට අවසර නැත.", en: "Microphone permission denied." },
  noncommercial_note: { si: "වාණිජ නොවන ප්‍රජා බෙදාගැනීමක් පමණි.", en: "Non-commercial, community sharing only." },
  otp_verify_first: { si: "දායක වීමට පළමුව විද්‍යුත් තැපෑල තහවුරු කරන්න", en: "Verify your email to contribute" },
  cancel: { si: "අවලංගු කරන්න", en: "Cancel" },
  post: { si: "පළ කරන්න", en: "Post" },
  // evening blessing
  eb_nav: { si: "සන්ධ්‍යා පහන", en: "Evening Blessing" },
  eb_title: { si: "සන්ධ්‍යා පහන", en: "Evening Blessing" },
  eb_sub: { si: "සැන්දෑවේ පහනක් දැල්වී, සන්සුන් මිහිරකින් දිනය නිමා කරමු.", en: "As dusk falls, light a lamp and end the day in calm melody." },
  eb_light: { si: "පහන දල්වන්න", en: "Light the lamp" },
  eb_not_now: { si: "දැන් නොවේ", en: "Not now" },
  eb_settings: { si: "සැකසුම්", en: "Settings" },
  eb_name: { si: "ඔබේ නම (විකල්ප)", en: "Your name (optional)" },
  eb_tradition: { si: "සම්ප්‍රදාය", en: "Tradition" },
  eb_time: { si: "සැන්දෑ වේලාව", en: "Evening time" },
  eb_enable: { si: "සෑම සැන්දෑවකම පහන දල්වන්න", en: "Light the lamp each evening" },
  eb_save: { si: "සුරකින්න", en: "Save" },
  eb_saved: { si: "සුරකින ලදි", en: "Saved" },
  eb_todays_lamp: { si: "අද දින පහන", en: "Today's lamp" },
  trad_buddhist: { si: "බෞද්ධ", en: "Buddhist" },
  trad_christian: { si: "ක්‍රිස්තියානි", en: "Christian" },
  trad_hindu: { si: "හින්දු", en: "Hindu" },
  trad_none: { si: "සාමාන්‍ය", en: "General" },
  // dedications
  dd_nav: { si: "පඬුරු ගී", en: "Dedications" },
  dd_title: { si: "පඬුරු ගී", en: "Song Dedications" },
  dd_sub: { si: "ආදරණීයයෙකුට කෙටි පණිවිඩයක් සමඟ ගීතයක් තෑගි කරන්න.", en: "Gift a song to a loved one with a short message." },
  dd_create: { si: "පඬුරක් තෑගි කරන්න", en: "Create a dedication" },
  dd_empty: { si: "තවම පඬුරු නැත — පළමුවැන්නා වන්න!", en: "No dedications yet — be the first!" },
  dd_to: { si: "කාටද?", en: "To" },
  dd_from: { si: "කාගෙන්ද?", en: "From" },
  dd_message: { si: "පණිවිඩය (විකල්ප)", en: "Message (optional)" },
  dd_pick_song: { si: "ගීතයක් තෝරන්න", en: "Choose a song" },
  dd_send: { si: "පඬුර යවන්න", en: "Send dedication" },
  dd_share: { si: "මෙම සබැඳිය බෙදාගන්න", en: "Share this link" },
  dd_copy: { si: "සබැඳිය පිටපත් කරන්න", en: "Copy link" },
  dd_copied: { si: "පිටපත් විය", en: "Copied" },
  dd_play: { si: "ගීතය අසන්න", en: "Play the song" },
  dd_for: { si: "සඳහා", en: "For" },
  dd_created: { si: "පඬුර සාදන ලදි!", en: "Dedication created!" },
  dd_open: { si: "විවෘත කරන්න", en: "Open" },
  dd_reveal: { si: "ඔබේ තෑග්ග විවෘත කිරීමට ඔබන්න", en: "Tap to open your gift" },
  dd_featured: { si: "විශේෂිත පඬුර", en: "Featured dedication" },
  feature: { si: "ඉස්මතු කරන්න", en: "Feature" },
  // listen together
  lt_nav: { si: "එකට අසන්න", en: "Listen Together" },
  lt_start: { si: "එකට අසමු", en: "Listen together" },
  lt_title: { si: "එකට අසන්න", en: "Listen Together" },
  lt_sub: { si: "සබැඳිය බෙදාගෙන, දුර සිටියත් එකම මොහොතේ එකට අසන්න.", en: "Share the link and hear the same song at the same moment, however far apart." },
  lt_pick: { si: "ගීතයක් තෝරා සැසියක් අරඹන්න", en: "Pick a song to start a session" },
  lt_create: { si: "සැසිය අරඹන්න", en: "Start session" },
  lt_share: { si: "මේ සබැඳිය බෙදාගන්න", en: "Share this link" },
  lt_copy: { si: "සබැඳිය පිටපත් කරන්න", en: "Copy link" },
  lt_host: { si: "ඔබ මෙහෙයවන්නා 🎧", en: "You're hosting 🎧" },
  lt_guest: { si: "මෙහෙයවන්නා සමඟ සමමුහුර්තයි", en: "In sync with the host" },
  lt_tap_join: { si: "එක්වීමට මෙතන ඔබන්න", en: "Tap here to join the listening" },
  lt_waiting: { si: "ගීතය පොරොත්තුවෙන්...", en: "Waiting for the song..." },
  // karaoke
  kar_sing: { si: "එක්ව ගයන්න", en: "Sing along" },
  kar_title: { si: "කැරෝකේ", en: "Karaoke" },
  // admin
  admin_title: { si: "ස්වාරාන්ජලිය · පාලක පුවරුව", en: "Swaranjaliya · Admin CMS" },
  admin_login: { si: "පිවිසෙන්න", en: "Sign in" },
  email: { si: "විද්‍යුත් තැපෑල", en: "Email" },
  password: { si: "මුරපදය", en: "Password" },
  logout: { si: "පිටවෙන්න", en: "Log out" },
  add_song: { si: "නව ගීතයක් එක් කරන්න", en: "Add a new song" },
  songs_table: { si: "ගීත", en: "Songs" },
  tab_songs: { si: "ගීත", en: "Songs" },
  tab_subs: { si: "එවූ සිංදු", en: "Submissions" },
  tab_ws: { si: "වැඩමුළුව", en: "Workshop" },
  tab_dd: { si: "පඬුරු", en: "Dedications" },
  ws_remove: { si: "ඉවත් කරන්න", en: "Remove" },
  sub_pending: { si: "සමාලෝචනය අපේක්ෂාවෙන්", en: "Pending review" },
  approve: { si: "අනුමත කරන්න", en: "Approve" },
  reject: { si: "ප්‍රතික්ෂේප කරන්න", en: "Reject" },
  no_subs: { si: "තවම එවූ සිංදු නැත.", en: "No submissions yet." },
  // poth kamare (audiobooks)
  pk_nav: { si: "පොත් කාමරේ", en: "Poth Kamare" },
  pk_title: { si: "පොත් කාමරේ — කථා හා ශ්‍රව්‍ය පොත්", en: "Poth Kamare — Stories & Audiobooks" },
  pk_sub: { si: "සන්සුන් හඬකින් කියවෙන කථා, ජාතක හා මතක සටහන් — ඇසින් නොව සවනින් රසවිඳින්න.", en: "Calm spoken-word stories, Jataka tales and memories — listen, and rest your eyes." },
  pk_banner_sub: { si: "ඇසින් නොව සවනින් රසවිඳින්න — කථා හා ශ්‍රව්‍ය පොත්.", en: "Rest your eyes and listen — stories and audiobooks." },
  pk_empty: { si: "තවම පොත් එකතු කර නැත.", en: "No audiobooks added yet." },
  pk_chapters: { si: "පරිච්ඡේද", en: "Chapters" },
  pk_chapter: { si: "පරිච්ඡේදය", en: "Chapter" },
  pk_listen: { si: "අසන්න", en: "Listen" },
  pk_resume: { si: "නැවත අරඹන්න", en: "Resume" },
  pk_by: { si: "කථනය", en: "Narrated by" },
  pk_play_book: { si: "මුල සිට අසන්න", en: "Play from start" },
  // favourites
  fav_title: { si: "ප්‍රියතම ගී", en: "Your favourites" },
  fav_filter: { si: "ප්‍රියතම", en: "Favourites" },
  fav_add: { si: "ප්‍රියතමයට එක් කරන්න", en: "Add to favourites" },
  fav_remove: { si: "ප්‍රියතමයෙන් ඉවත් කරන්න", en: "Remove from favourites" },
  fav_empty: { si: "තවම ප්‍රියතම ගී නැත. හදවත ඔබා එක් කරන්න.", en: "No favourites yet. Tap the heart on a song to save it." },
  fav_saved: { si: "මෙම උපාංගයේ සුරකින ලදි", en: "Saved on this device" },
  // collections / albums
  col_title: { si: "ගී එකතු", en: "Collections" },
  col_sub: { si: "තේමාවෙන් තෝරාගත් ගී එකතු.", en: "Hand-picked albums by mood and theme." },
  col_play_all: { si: "සියල්ල වාදනය කරන්න", en: "Play all" },
  col_songs: { si: "ගී", en: "songs" },
  col_open: { si: "විවෘත කරන්න", en: "Open" },
  // sponsor
  sp_by: { si: "අනුග්‍රහයෙන්", en: "Brought to you by" },
  // admin extra
  tab_books: { si: "පොත්", en: "Audiobooks" },
  tab_col: { si: "එකතු", en: "Collections" },
  tab_sponsor: { si: "අනුග්‍රහය", en: "Sponsor" },
  add_book: { si: "නව පොතක් එක් කරන්න", en: "Add an audiobook" },
  add_chapter: { si: "පරිච්ඡේදයක් එක් කරන්න", en: "Add a chapter" },
  // sharing + featured book
  share: { si: "බෙදාගන්න", en: "Share" },
  wa_share: { si: "WhatsApp හරහා බෙදාගන්න", en: "Share on WhatsApp" },
  link_copied: { si: "සබැඳිය පිටපත් විය", en: "Link copied" },
  pk_featured: { si: "අද දින විශේෂ පොත", en: "Featured audiobook" },
  // poya observance
  poya_today: { si: "අද පොහොය දිනයයි", en: "Today is a Poya day" },
  poya_eve: { si: "හෙට පොහොය දිනයයි", en: "Tomorrow is a Poya day" },
  poya_listen: { si: "පොහොය පහන දල්වන්න", en: "Light the Poya lamp" },
  poya_meheni: { si: "මෙහෙණි සසුනට නමස්කාරයි", en: "Honouring the Meheni Sasana" },
  meheni_title: { si: "මෙහෙණි හඬ — කාන්තා ගැයුම්", en: "Meheni Voices — women's songs" },
  meheni_note: { si: "භික්ෂුණී සසුන පිහිටුවීම සිහිකරමින්, කාන්තා ගායිකාවන්ට හා මෙහෙණින් වහන්සේලාට ගෞරවයෙන්.", en: "Honouring women artists and nuns, in memory of the founding of the Bhikkhuni Sasana." },
  // story kamare (kids' folk tales & bedtime stories)
  st_nav: { si: "කතන්දර කාමරේ", en: "Story Kamare" },
  st_title: { si: "කතන්දර කාමරේ — දරුවන්ට කතන්දර", en: "Story Kamare — tales for little ones" },
  st_sub: { si: "මුත්තා-ආච්චිලාට මුණුබුරන්ට කියවන්නට, සන්සුන් හඬින් කියවෙන ජනකතා හා නිදි කතන්දර.", en: "Gentle folk tales and bedtime stories for grandparents to share with their grandchildren." },
  st_banner_sub: { si: "මුණුබුරන්ට කියවන්නට සුදුසු ජනකතා හා නිදි කතන්දර.", en: "Folk tales and bedtime stories to play for the grandchildren." },
  st_empty: { si: "තවම කතන්දර එකතු කර නැත.", en: "No stories added yet." },
  // rooms hub + new rooms
  rooms_title: { si: "කාමර", en: "Rooms" },
  rooms_sub: { si: "නෙඔක්ස් ස්වාරාන්ජලිය ලෝකයට ඇතුළු වන්න.", en: "Step into the rooms of Neox Swaranjaliya." },
  wg_nav: { si: "වැඩිහිටි ගායකයෝ", en: "Elder Singers" },
  wg_title: { si: "වැඩිහිටි ගායකයෝ — ඔබේම හඬින්", en: "Elder Singers — voices of our elders" },
  wg_sub: { si: "වැඩිහිටි ගායක ගායිකාවන්ගේ ගී — ගෞරවයෙන් හා ආදරයෙන්.", en: "Recordings by senior artists — shared with respect and love." },
  bh_nav: { si: "භාවනා කාමරේ", en: "Bhavana Kamare" },
  bh_title: { si: "භාවනා කාමරේ — සන්සුන් සිතක්", en: "Bhavana Kamare — a calm mind" },
  bh_sub: { si: "භාවනා, හුස්ම ගැනීම හා සන්සුන් නාද — නිදහසේ විවේක ගන්න.", en: "Meditation, breathing and gentle calming sounds — rest and unwind." },
  // family across the miles
  fam_title: { si: "දුර ඈත පවුලට", en: "Family across the miles" },
  fam_sub: { si: "දුරින් සිටියත් හදවතින් ළඟ — ඔබේම හඬින් හා සිහිකිරීමෙන් පවුල එකට.", en: "Far in miles, close in heart — connect the family with your own voice and remembrance." },
  // in your own voice
  voice_nav: { si: "ඔබේම හඬින්", en: "In Your Own Voice" },
  voice_title: { si: "ඔබේම හඬින් — පවුලට පණිවිඩයක්", en: "In Your Own Voice — a message for family" },
  voice_sub: { si: "කෙටි පණිවිඩයක්, ආශිර්වාදයක් හෝ නිදි කතන්දරයක් ඔබේම හඬින් පටිගත කර, දුර සිටින දරු මුණුබුරන්ට යවන්න.", en: "Record a short message, a blessing or a bedtime tale in your own voice, and send it to family abroad." },
  voice_kind_message: { si: "පණිවිඩය", en: "Message" },
  voice_kind_blessing: { si: "ආශිර්වාදය", en: "Blessing" },
  voice_kind_story: { si: "කතන්දරය", en: "Story" },
  voice_from: { si: "ඔබේ නම", en: "Your name" },
  voice_to: { si: "කාටද? (විකල්ප)", en: "For whom? (optional)" },
  voice_msg: { si: "වචන කිහිපයක් (විකල්ප)", en: "A few words (optional)" },
  voice_send: { si: "පටිගත කර යවන්න", en: "Save & get share link" },
  voice_created: { si: "ඔබේ හඬ පණිවිඩය සුරකින ලදි!", en: "Your voice message is ready!" },
  voice_for: { si: "සඳහා", en: "For" },
  voice_record_hint: { si: "පටිගත කිරීමට බොත්තම ඔබන්න, කතා කර නැවතත් ඔබන්න.", en: "Tap to record, speak, then tap to stop." },
  // punyanumodana / remembrance
  rem_nav: { si: "පුණ්‍යානුමෝදනා", en: "Remembrance" },
  rem_title: { si: "පුණ්‍යානුමෝදනා — සිහිකිරීම", en: "Punyanumodana — Remembrance" },
  rem_sub: { si: "අප හැර ගිය ආදරණීයයන් සිහිකරමින්, මුළු පවුලම එකට පිං අනුමෝදන් වෙමු — දුර සිටියත්.", en: "Remembering our departed loved ones, the whole family shares merit together — even from afar." },
  rem_today: { si: "අද දින සිහිකිරීම", en: "Today's remembrance" },
  rem_create: { si: "සිහිකිරීමක් එක් කරන්න", en: "Create a remembrance" },
  rem_name: { si: "අභාවප්‍රාප්තයාගේ නම", en: "Name of the departed" },
  rem_date: { si: "අභාවප්‍රාප්ත වූ දිනය", en: "Date of passing" },
  rem_note: { si: "වචන කිහිපයක් (විකල්ප)", en: "A few words (optional)" },
  rem_photo: { si: "ඡායාරූපය (විකල්ප)", en: "Photo (optional)" },
  rem_save: { si: "සුරකින්න", en: "Save" },
  rem_sadhu: { si: "පහන දල්වා පිං අනුමෝදන් වන්න — සාදු!", en: "Light a lamp & share merit — Sādhu!" },
  rem_sadhu_count: { si: "වතාවක් පිං අනුමෝදන් විය", en: "times merit shared" },
  rem_listen: { si: "පිරිත් සවන් දෙන්න", en: "Listen to pirith" },
  rem_tribute: { si: "සිහිකිරීමක් එක් කරන්න", en: "Add a remembrance note" },
  rem_tribute_name: { si: "ඔබේ නම", en: "Your name" },
  rem_tribute_text: { si: "වචන කිහිපයක්", en: "A few words" },
  rem_tribute_send: { si: "එක් කරන්න", en: "Add" },
  rem_empty: { si: "තවම සිහිකිරීම් නැත.", en: "No remembrances yet." },
  open: { si: "විවෘත කරන්න", en: "Open" },
  // wada baila kamare (verse duel)
  wb_nav: { si: "වාද බයිලා කාමරේ", en: "Wada Baila Kamare" },
  wb_title: { si: "වාද බයිලා කාමරේ — පදෙන් පදයට", en: "Wada Baila Kamare — trade verse for verse" },
  wb_sub: { si: "ඔබ පදයක් ලියන්න, එයට පිළිතුරු පදයක් ලැබෙනවා — දක්ෂ, විහිළු බර වාද බයිලා දෙබසක්.", en: "Sing a verse, get a clever rhyming verse back — a witty, playful baila duel." },
  wb_mode_ai: { si: "යෙදුම සමඟ", en: "Play the app" },
  wb_mode_human: { si: "දෙදෙනෙක්", en: "Two players" },
  wb_you: { si: "ඔබ", en: "You" },
  wb_app: { si: "යෙදුම", en: "The app" },
  wb_p1: { si: "පළමුවැන්නා", en: "Player 1" },
  wb_p2: { si: "දෙවැන්නා", en: "Player 2" },
  wb_turn: { si: "වාරය:", en: "Turn:" },
  wb_input_hint: { si: "ඔබේ පදය මෙහි ලියන්න...", en: "Write your verse here..." },
  wb_send: { si: "පදය යවන්න", en: "Send verse" },
  wb_thinking: { si: "පිළිතුරු පදය නිර්මාණය වෙමින්...", en: "Composing a reply verse..." },
  wb_read: { si: "හඬින් කියවන්න", en: "Read aloud" },
  wb_stop_read: { si: "නවත්වන්න", en: "Stop" },
  wb_empty: { si: "පළමු පදය ලියා දෙබස අරඹන්න.", en: "Write the first verse to begin the duel." },
  wb_new: { si: "අලුත් දෙබසක්", en: "New duel" },
  wb_error: { si: "පිළිතුරු පදය සෑදිය නොහැකි විය. නැවත උත්සාහ කරන්න.", en: "Could not compose a reply. Please try again." },
  wb_wrote: { si: "පදය:", en: "Verse:" },
  wb_type: { si: "ලියන්න", en: "Type" },
  wb_duels_played: { si: "දෙබස් ගණන", en: "duels played" },
  wb_like: { si: "මේක සුපිරි!", en: "Loved it!" },
  wb_liked: { si: "ස්තූතියි ❤", en: "Thanks ❤" },
  wb_share_duel: { si: "මුළු දෙබසම බෙදාගන්න", en: "Share the whole duel" },
  wb_stat_duels: { si: "මුළු දෙබස්", en: "Total duels" },
  wb_stat_likes: { si: "මුළු ❤", en: "Total likes" },
  wb_stats_title: { si: "වාද බයිලා නැරඹුම්", en: "Wada Baila activity" },
  wb_tone: { si: "විලාසය", en: "Style" },
  wb_tone_classic: { si: "සම්ප්‍රදායික", en: "Classic" },
  wb_tone_funny: { si: "විහිළු", en: "Funny" },
  wb_tone_cheeky: { si: "දඟකාර", en: "Cheeky" },
  wb_tone_romantic: { si: "ආදර", en: "Romantic" },
  wb_tone_rap: { si: "රැප්", en: "Rap" },
  wb_play: { si: "දෙබස", en: "Play" },
  wb_hall: { si: "බයිලා ශාලාව", en: "Hall of Baila" },
  wb_save_hall: { si: "ශාලාවට සුරකින්න", en: "Save to Hall" },
  wb_saved_hall: { si: "ශාලාවට එක් කළා ✓", en: "Saved to Hall ✓" },
  wb_hall_empty: { si: "තවම සුරැකි දෙබස් නැත — පළමු එක ඔබෙන්!", en: "No saved duels yet — be the first!" },
  wb_hall_sub: { si: "වඩාත්ම ප්‍රියජනක දෙබස් — ❤ දාලා ඉහළට ගෙනියන්න.", en: "The most-loved duels — tap ❤ to push your favourites up." },
  wb_round: { si: "වටය", en: "Round" },
  wb_challenge_title: { si: "අද දවසේ අභියෝගය", en: "Today's challenge" },
  wb_challenge_reply: { si: "මේකට පිළිතුරු දෙන්න", en: "Reply to this" },
  wb_someone: { si: "යමෙක්", en: "Someone" },
  wb_challenge_family: { si: "පවුලේ අයෙකුට අභියෝග කරන්න", en: "Challenge a family member" },
  wb_challenge_msg: { si: "ඔබට වාද බයිලා පදයක් ගයනවා — පිළිතුරු දෙන්න පුළුවන්ද? දෙබසට එකතු වෙන්න 👇", en: "sings a baila verse for you — can you sing back? Tap to join the duel 👇" },
  wb_challenged_you: { si: "ඔබට වාද බයිලා අභියෝගයක් කර ඇත! පිළිතුරු පදය පහළින් ගයන්න 👇", en: "has challenged you to a baila duel! Sing your reply below 👇" },
  wb_send_back: { si: "පිළිතුර ආපසු යවන්න →", en: "Send your reply back to" },
  wb_ask_name: { si: "ඔබේ නම (කවුද අභියෝග කරන්නේ කියා පවුලේ අයට දැනගන්න):", en: "Your name (so family knows who's challenging them):" },
};

// Tamil overlay — UI chrome in Tamil. Falls back to English where missing.
const taDict = {
  brand: "சிந்து காமரே", brand_sub: "நியோக்ஸ்", admin: "நிர்வாகம்",
  hero_title: "சிந்து காமரே — இலங்கையின் இனிய பழம் பாடல்கள்",
  hero_sub: "அமைதியான பழைய சிங்கள பாடல்கள், வீணை, தபலா — விளக்கேற்றுவது போல் இசை.",
  play_all: "அனைத்தையும் இசை", featured: "இன்றைய புதிய பாடல்கள்", featured_sub: "இன்றைய சிறப்புப் பாடல்கள்",
  full_list: "முழுப் பாடல் தொகுப்பு", full_list_sub: "முழுத் தொகுப்பு",
  no_songs: "இன்னும் பாடல்கள் சேர்க்கப்படவில்லை.", loading: "ஏற்றுகிறது...",
  play: "இசை", pause: "நிறுத்து", prev: "முந்தைய பாடல்", next: "அடுத்த பாடல்", auto_next: "தானாக அடுத்தது",
  tap_continue: "தொடர்ந்து இசைக்க இங்கே தட்டவும்", now_playing: "இப்போது இசைக்கிறது",
  sleep: "உறக்க நேரம்", sleep_off: "அணை", sleep_end: "பாடல் முடிவில்", sleep_min: "நிமிடம்", sleep_on: "உறக்கம்:",
  quiet_note: "மனதைப் புத்துணர்ச்சியாக்கும் · கண்காணிப்பு இல்லை · அமைதியான கேட்டல்",
  filters_all: "அனைத்தும்", filters_calm: "அமைதிப் பாடல்கள்", filters_veena: "வீணை", filters_tabla: "தபலா",
  back_room: "அறைக்குத் திரும்பு",
  submit_nav: "உங்கள் பாடலை அனுப்புங்கள்", submit_title: "உங்கள் பதிவைப் பகிருங்கள்",
  submit_sub: "புதிய பாடகர்கள் தங்கள் பதிவுகளை அனுப்பலாம். முதலில் உங்கள் மின்னஞ்சலை உறுதிப்படுத்துங்கள்.",
  submit_email_label: "உங்கள் மின்னஞ்சல்", submit_send_code: "குறியீட்டை அனுப்பு",
  submit_code_label: "மின்னஞ்சலில் வந்த குறியீட்டை உள்ளிடுங்கள்", submit_verify: "உறுதிப்படுத்து",
  submit_resend: "மீண்டும் அனுப்பு", submit_change_email: "மின்னஞ்சலை மாற்று", submit_form_title: "பாடல் விவரங்கள்",
  f_title_en: "பாடல் தலைப்பு (ஆங்கிலம்)", f_title_si: "பாடல் தலைப்பு (சிங்களம்)", f_artist: "கலைஞர்",
  f_singer_name: "உங்கள் பெயர்", f_contact: "தொலைபேசி / தொடர்பு (விருப்பம்)", f_year: "ஆண்டு (விருப்பம்)",
  f_tags: "குறிச்சொற்கள் (கமாவால் பிரிக்கவும்)", f_notes: "குறிப்புகள் (விருப்பம்)",
  f_audio: "ஒலிக் கோப்பு (MP3)", f_cover: "அட்டைப் படம் (விருப்பம்)",
  consent_label: "இந்தப் பதிவின் உரிமை என்னிடம் உள்ளது, அதை நியோக்ஸ் சிந்து காமரேயில் பகிர சம்மதிக்கிறேன்.",
  submit_btn: "பாடலை அனுப்பு", submit_done_title: "நன்றி! உங்கள் பாடல் கிடைத்தது.",
  submit_done_sub: "எங்கள் குழு அதை மதிப்பாய்வு செய்து விரைவில் சேர்க்கும்.", submit_another: "மற்றொன்றை அனுப்பு",
  ws_nav: "படைப்புப் பட்டறை", ws_title: "படைப்புப் பட்டறை",
  ws_sub: "பாடலாசிரியர்கள் வரிகள் எழுதுவர் · இசையமைப்பாளர்கள் இசை சேர்ப்பர் · பாடகர்கள் பாடுவர். வணிகமற்ற சமூகப் பகிர்வு மட்டுமே.",
  ws_post: "வரிகளைப் பதிவிடு", ws_empty: "இன்னும் படைப்புகள் இல்லை — முதலாவதாக இருங்கள்!",
  ws_new_title: "புதிய வரிகள் படைப்பு", ws_field_title: "தலைப்பு", ws_field_lyrics: "வரிகள்",
  ws_field_author: "உங்கள் பெயர்", ws_field_tags: "குறிச்சொற்கள் (கமாவால்)", ws_melodies: "இசைகள்", ws_vocals: "பாடல் பதிவுகள்",
  ws_none_melody: "இன்னும் இசை இல்லை.", ws_none_vocal: "இன்னும் பாடல் பதிவு இல்லை.",
  ws_add_melody: "ஒரு இசையைச் சேர்", ws_sing: "பாடு / பதிவு செய்", ws_upload_take: "முடிந்த பதிவை பதிவேற்று",
  ws_composer: "இசையமைப்பாளர் பெயர்", ws_singer: "பாடகர் பெயர்", ws_instrumental: "இசை (கருவி ஒலி)",
  ws_pick_melody: "பாட ஒரு இசையைத் தேர்ந்தெடு", ws_record: "பதிவைத் தொடங்கு", ws_stop: "நிறுத்து",
  ws_rerecord: "மீண்டும் பதிவு செய்", ws_balance: "குரல் / இசை சமநிலை", ws_mixing: "கலக்கிறது...",
  ws_publish_take: "பதிவை வெளியிடு", ws_open: "திற", ws_by: "எழுதியவர்",
  recording_now: "பதிவாகிறது...", mic_denied: "மைக்ரோஃபோன் அனுமதி மறுக்கப்பட்டது.",
  noncommercial_note: "வணிகமற்ற சமூகப் பகிர்வு மட்டுமே.", otp_verify_first: "பங்களிக்க உங்கள் மின்னஞ்சலை உறுதிப்படுத்துங்கள்",
  cancel: "ரத்து செய்", post: "பதிவிடு",
  eb_nav: "மாலை ஆசி", eb_title: "மாலை ஆசி", eb_sub: "மாலை வரும்போது, ஒரு விளக்கேற்றி, அமைதி இசையில் நாளை முடிப்போம்.",
  eb_light: "விளக்கேற்று", eb_not_now: "இப்போது வேண்டாம்", eb_settings: "அமைப்புகள்", eb_name: "உங்கள் பெயர் (விருப்பம்)",
  eb_tradition: "மரபு", eb_time: "மாலை நேரம்", eb_enable: "ஒவ்வொரு மாலையும் விளக்கேற்று", eb_save: "சேமி", eb_saved: "சேமிக்கப்பட்டது",
  eb_todays_lamp: "இன்றைய விளக்கு", trad_buddhist: "பௌத்தம்", trad_christian: "கிறிஸ்தவம்", trad_hindu: "இந்து", trad_none: "பொது",
  dd_nav: "பாடல் காணிக்கை", dd_title: "பாடல் காணிக்கைகள்", dd_sub: "ஒரு அன்பானவருக்கு சிறு செய்தியுடன் ஒரு பாடலைப் பரிசளியுங்கள்.",
  dd_create: "ஒரு காணிக்கை உருவாக்கு", dd_empty: "இன்னும் காணிக்கைகள் இல்லை — முதலாவதாக இருங்கள்!",
  dd_to: "யாருக்கு?", dd_from: "யாரிடமிருந்து?", dd_message: "செய்தி (விருப்பம்)", dd_pick_song: "ஒரு பாடலைத் தேர்ந்தெடு",
  dd_send: "காணிக்கையை அனுப்பு", dd_share: "இந்த இணைப்பைப் பகிர்", dd_copy: "இணைப்பை நகலெடு", dd_copied: "நகலெடுக்கப்பட்டது",
  dd_play: "பாடலைக் கேள்", dd_for: "க்காக", dd_created: "காணிக்கை உருவாக்கப்பட்டது!", dd_open: "திற",
  dd_reveal: "உங்கள் பரிசைத் திறக்க தட்டவும்", dd_featured: "சிறப்புக் காணிக்கை", feature: "சிறப்பி",
  lt_nav: "ஒன்றாகக் கேள்", lt_start: "ஒன்றாகக் கேட்போம்", lt_title: "ஒன்றாகக் கேள்",
  lt_sub: "இணைப்பைப் பகிர்ந்து, தொலைவில் இருந்தாலும் ஒரே நேரத்தில் ஒன்றாகக் கேளுங்கள்.",
  lt_pick: "ஒரு பாடலைத் தேர்ந்து அமர்வைத் தொடங்கு", lt_create: "அமர்வைத் தொடங்கு", lt_share: "இந்த இணைப்பைப் பகிர்",
  lt_copy: "இணைப்பை நகலெடு", lt_host: "நீங்கள் நடத்துகிறீர்கள் 🎧", lt_guest: "நடத்துபவருடன் ஒத்திசைவில்",
  lt_tap_join: "சேர இங்கே தட்டவும்", lt_waiting: "பாடலுக்காகக் காத்திருக்கிறது...",
  kar_sing: "உடன் பாடு", kar_title: "கரோக்கே",
  admin_title: "சிந்து காமரே · நிர்வாகம்", admin_login: "உள்நுழை", email: "மின்னஞ்சல்", password: "கடவுச்சொல்", logout: "வெளியேறு",
  add_song: "புதிய பாடலைச் சேர்", songs_table: "பாடல்கள்", tab_songs: "பாடல்கள்", tab_subs: "அனுப்பியவை",
  tab_ws: "பட்டறை", tab_dd: "காணிக்கைகள்", ws_remove: "அகற்று", sub_pending: "மதிப்பாய்வு நிலுவையில்",
  approve: "அங்கீகரி", reject: "நிராகரி", no_subs: "இன்னும் அனுப்பப்பட்ட பாடல்கள் இல்லை.",
  pk_nav: "பொத் காமரே", pk_title: "பொத் காமரே — கதைகள் & ஒலிப் புத்தகங்கள்",
  pk_sub: "அமைதியான குரலில் சொல்லப்படும் கதைகள், ஜாதகக் கதைகள், நினைவுகள் — கண்களை ஓய்வெடுத்து கேளுங்கள்.",
  pk_banner_sub: "கண்களை ஓய்வெடுத்து கேளுங்கள் — கதைகள் & ஒலிப் புத்தகங்கள்.",
  pk_empty: "இன்னும் ஒலிப் புத்தகங்கள் இல்லை.", pk_chapters: "அத்தியாயங்கள்", pk_chapter: "அத்தியாயம்",
  pk_listen: "கேள்", pk_resume: "மீண்டும் தொடங்கு", pk_by: "விவரித்தவர்", pk_play_book: "ஆரம்பத்திலிருந்து கேள்",
  fav_title: "உங்கள் பிடித்தவை", fav_filter: "பிடித்தவை", fav_add: "பிடித்தவைக்குச் சேர்", fav_remove: "பிடித்தவையிலிருந்து அகற்று",
  fav_empty: "இன்னும் பிடித்த பாடல்கள் இல்லை. ஒரு பாடலில் இதயத்தைத் தட்டிச் சேமியுங்கள்.", fav_saved: "இந்தச் சாதனத்தில் சேமிக்கப்பட்டது",
  col_title: "தொகுப்புகள்", col_sub: "மனநிலை மற்றும் கருப்பொருளால் தேர்ந்தெடுக்கப்பட்ட ஆல்பங்கள்.",
  col_play_all: "அனைத்தையும் இசை", col_songs: "பாடல்கள்", col_open: "திற",
  sp_by: "வழங்குபவர்", tab_books: "ஒலிப் புத்தகங்கள்", tab_col: "தொகுப்புகள்", tab_sponsor: "வழங்குநர்",
  add_book: "ஒரு ஒலிப் புத்தகத்தைச் சேர்", add_chapter: "ஒரு அத்தியாயத்தைச் சேர்",
  share: "பகிர்", wa_share: "WhatsApp இல் பகிர்", link_copied: "இணைப்பு நகலெடுக்கப்பட்டது", pk_featured: "சிறப்பு ஒலிப் புத்தகம்",
  poya_today: "இன்று பௌயா தினம்", poya_eve: "நாளை பௌயா தினம்", poya_listen: "பௌயா விளக்கேற்று", poya_meheni: "மெஹேணி சாசனத்திற்கு வணக்கம்",
  meheni_title: "மெஹேணி குரல்கள் — பெண்களின் பாடல்கள்", meheni_note: "பிக்குணி சாசனம் நிறுவப்பட்டதை நினைவுகூர்ந்து, பெண் கலைஞர்களுக்கும் துறவிகளுக்கும் வணக்கம்.",
  st_nav: "கதை காமரே", st_title: "கதை காமரே — சிறுவர்களுக்கான கதைகள்", st_sub: "தாத்தா-பாட்டிகள் பேரக்குழந்தைகளுக்குச் சொல்ல, அமைதியான குரலில் நாட்டுப்புறக் கதைகளும் தூங்கும் கதைகளும்.", st_banner_sub: "பேரக்குழந்தைகளுக்குச் சொல்ல நாட்டுப்புறக் கதைகளும் தூங்கும் கதைகளும்.", st_empty: "இன்னும் கதைகள் சேர்க்கப்படவில்லை.",
  rooms_title: "அறைகள்", rooms_sub: "நியோக்ஸ் சிந்து காமரே அறைகளுக்குள் நுழையுங்கள்.",
  wg_nav: "மூத்த பாடகர்கள்", wg_title: "மூத்த பாடகர்கள் — நம் பெரியோரின் குரல்கள்", wg_sub: "மூத்த கலைஞர்களின் பதிவுகள் — மரியாதையுடனும் அன்புடனும்.",
  bh_nav: "பாவனா காமரே", bh_title: "பாவனா காமரே — அமைதியான மனம்", bh_sub: "தியானம், மூச்சுப் பயிற்சி மற்றும் அமைதியான ஒலிகள் — ஓய்வெடுங்கள்.",
  fam_title: "தொலைவில் உள்ள குடும்பத்திற்கு", voice_nav: "உங்கள் சொந்தக் குரலில்", voice_title: "உங்கள் சொந்தக் குரலில் — குடும்பத்திற்கு ஒரு செய்தி",
  rem_nav: "புண்யானுமோதனா", rem_title: "புண்யானுமோதனா — நினைவுகூர்தல்", rem_sadhu: "விளக்கேற்றி புண்ணியத்தைப் பகிருங்கள் — சாது!",
  wb_nav: "வாத பாய்லா காமரே", wb_title: "வாத பாய்லா காமரே — வரிக்கு வரி",
  wb_sub: "ஒரு வரி பாடுங்கள், ஒரு புத்திசாலித்தனமான பதில் வரி கிடைக்கும் — நகைச்சுவையான பாய்லா சண்டை.",
  wb_mode_ai: "செயலியுடன்", wb_mode_human: "இருவர்", wb_you: "நீங்கள்", wb_app: "செயலி",
  wb_p1: "ஆட்டக்காரர் 1", wb_p2: "ஆட்டக்காரர் 2", wb_turn: "முறை:",
  wb_input_hint: "உங்கள் வரியை இங்கே எழுதுங்கள்...", wb_send: "வரியை அனுப்பு",
  wb_thinking: "பதில் வரி உருவாக்கப்படுகிறது...", wb_read: "சத்தமாக வாசி", wb_stop_read: "நிறுத்து",
  wb_empty: "முதல் வரியை எழுதி சண்டையைத் தொடங்குங்கள்.", wb_new: "புதிய சண்டை",
  wb_error: "பதில் வரியை உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.", wb_wrote: "வரி:",
  music_credit_bg: "பின்னணி இசை", music_credit_lic: "CC BY 4.0 உரிமத்தின் கீழ்",
  invite_send: "குடும்பத்தையும் நண்பர்களையும் அழைக்கவும்",
  poets_corner: "கவிதை மூலை — உங்கள் கவிதையை எழுதுங்கள்",
  karaoke: "கரோக்கே அறை — உறுப்பினர்களுக்கு",
  ideas_wall: "இலங்கைக்கான யோசனைகள் — உங்கள் குரல்",
  friends_wall: "இலங்கையின் நண்பர்கள் — உலகிலிருந்து",
  heritage_wall: "இலங்கையின் வாழும் பாரம்பரியம்",
  poster_download: "சுவரொட்டியைப் பதிவிறக்கு",
  invite_msg: "🪔 சிந்து காமரே — நம் பெரியோருக்கு அமைதியான பழம் பாடல்கள், கதைகள், தியானம். மனதைப் புத்துணர்ச்சியாக்கும், உள்நுழைவு இல்லை, இலவசம். இங்கே கேளுங்கள்:",
  sotd_save_img: "படத்தை சேமிக்கவும்",
  sotd_family_send: "இன்றைய பாடலை என் குடும்பக் குழுவிற்கு அனுப்பு",
  sotd_family_msg: "🪔 முழு குடும்பத்திற்கும் — இன்றைய சிந்து காமரே பாடல் 🎶",
  share_card_listen: "neox.lk இல் இலவசமாக கேளுங்கள்",
  invite_page_tag: "அமைதியான பழம் பாடல்கள் · கதைகள் · தியானம்",
  invite_page_sub: "உள்நுழைவு இல்லை · இலவசம் · எப்போதும்",
  invite_listen_free: "இலவசமாக கேட்கத் தொடங்குங்கள்",
  listeners_joined: "பேர் ஏற்கனவே கேட்கிறார்கள்",
  sotd_title: "இன்றைய பாடல்", sotd_greet: "இன்று உங்களுக்கு ஒரு சிறு பரிசு 🌸",
  sotd_g_morning: "காலை வணக்கம், நண்பரே 🌅", sotd_g_afternoon: "மதிய வணக்கம், நண்பரே ☀️", sotd_g_evening: "மாலை வணக்கம், நண்பரே 🌇", sotd_g_night: "இனிய இரவு, நண்பரே 🌙",
};

// Hindi overlay — diaspora / Indian-language clone template. Falls back to English where missing.
const hiDict = {
  brand: "सिंधु कामरे", brand_sub: "नियोक्स", admin: "व्यवस्थापक",
  hero_title: "सिंधु कामरे — श्रीलंका के मधुर पुराने गीत",
  hero_sub: "शांत पुराने गीत, वीणा और तबला — जैसे दीप जलाकर सुना जाए, वैसा संगीत।",
  play_all: "सभी बजाएँ", featured: "आज के नए गीत", featured_sub: "आज के विशेष गीत",
  full_list: "पूरा गीत संग्रह", full_list_sub: "पूरा संग्रह",
  no_songs: "अभी कोई गीत नहीं जोड़ा गया।", loading: "लोड हो रहा है...",
  play: "बजाएँ", pause: "रोकें", prev: "पिछला गीत", next: "अगला गीत", auto_next: "स्वतः अगला",
  tap_continue: "बजाना जारी रखने के लिए यहाँ टैप करें", now_playing: "अभी बज रहा है",
  sleep: "स्लीप टाइमर", sleep_off: "बंद", sleep_end: "गीत के अंत में", sleep_min: "मिनट", sleep_on: "स्लीप:",
  quiet_note: "मन को ताज़ा करने वाला · कोई ट्रैकिंग नहीं · शांत श्रवण",
  filters_all: "सभी", filters_calm: "शांत गीत", filters_veena: "वीणा", filters_tabla: "तबला",
  back_room: "कक्ष में लौटें",
  submit_nav: "अपना गीत भेजें", submit_title: "अपनी रिकॉर्डिंग साझा करें",
  submit_sub: "नए गायक अपनी रिकॉर्डिंग भेज सकते हैं। पहले अपना ईमेल सत्यापित करें।",
  submit_email_label: "आपका ईमेल", submit_send_code: "कोड भेजें",
  submit_code_label: "ईमेल में भेजा गया कोड दर्ज करें", submit_verify: "सत्यापित करें",
  submit_resend: "कोड पुनः भेजें", submit_change_email: "ईमेल बदलें", submit_form_title: "गीत विवरण",
  f_title_en: "गीत शीर्षक (अंग्रेज़ी)", f_title_si: "गीत शीर्षक (सिंहल)", f_artist: "कलाकार",
  f_singer_name: "आपका नाम", f_contact: "फ़ोन / संपर्क (वैकल्पिक)", f_year: "वर्ष (वैकल्पिक)",
  f_tags: "टैग (अल्पविराम से अलग)", f_notes: "टिप्पणियाँ (वैकल्पिक)",
  f_audio: "ऑडियो फ़ाइल (MP3)", f_cover: "कवर छवि (वैकल्पिक)",
  consent_label: "मैं पुष्टि करता हूँ कि इस रिकॉर्डिंग का अधिकार मेरे पास है और इसे नियोक्स सिंधु कामरे पर साझा करने की सहमति देता हूँ।",
  submit_btn: "गीत भेजें", submit_done_title: "धन्यवाद! आपका गीत प्राप्त हुआ।",
  submit_done_sub: "हमारी टीम इसकी समीक्षा कर शीघ्र ही जोड़ेगी।", submit_another: "एक और भेजें",
  ws_nav: "रचना कार्यशाला", ws_title: "रचना कार्यशाला",
  ws_sub: "गीतकार शब्द लिखते हैं · संगीतकार धुन जोड़ते हैं · गायक गाते हैं। केवल गैर-व्यावसायिक सामुदायिक साझाकरण।",
  ws_post: "बोल पोस्ट करें", ws_empty: "अभी कोई रचना नहीं — पहले बनें!",
  ws_new_title: "नई बोल रचना", ws_field_title: "शीर्षक", ws_field_lyrics: "बोल",
  ws_field_author: "आपका नाम", ws_field_tags: "टैग (अल्पविराम से)", ws_melodies: "धुनें", ws_vocals: "गायन",
  ws_none_melody: "अभी कोई धुन नहीं।", ws_none_vocal: "अभी कोई गायन नहीं।",
  ws_add_melody: "एक धुन जोड़ें", ws_sing: "गाएँ / रिकॉर्ड करें", ws_upload_take: "पूर्ण गायन अपलोड करें",
  ws_composer: "संगीतकार का नाम", ws_singer: "गायक का नाम", ws_instrumental: "धुन (वाद्य ऑडियो)",
  ws_pick_melody: "गाने के लिए धुन चुनें", ws_record: "रिकॉर्डिंग शुरू करें", ws_stop: "रोकें",
  ws_rerecord: "फिर से रिकॉर्ड करें", ws_balance: "आवाज़ / धुन संतुलन", ws_mixing: "मिश्रण हो रहा है...",
  ws_publish_take: "गायन प्रकाशित करें", ws_open: "खोलें", ws_by: "द्वारा",
  recording_now: "रिकॉर्ड हो रहा है...", mic_denied: "माइक्रोफ़ोन की अनुमति नहीं मिली।",
  noncommercial_note: "केवल गैर-व्यावसायिक सामुदायिक साझाकरण।", otp_verify_first: "योगदान के लिए अपना ईमेल सत्यापित करें",
  cancel: "रद्द करें", post: "पोस्ट करें",
  eb_nav: "संध्या आशीर्वाद", eb_title: "संध्या आशीर्वाद", eb_sub: "संध्या ढलते ही, एक दीप जलाएँ और शांत संगीत के साथ दिन समाप्त करें।",
  eb_light: "दीप जलाएँ", eb_not_now: "अभी नहीं", eb_settings: "सेटिंग्स", eb_name: "आपका नाम (वैकल्पिक)",
  eb_tradition: "परंपरा", eb_time: "संध्या समय", eb_enable: "हर संध्या दीप जलाएँ", eb_save: "सहेजें", eb_saved: "सहेजा गया",
  eb_todays_lamp: "आज का दीप", trad_buddhist: "बौद्ध", trad_christian: "ईसाई", trad_hindu: "हिंदू", trad_none: "सामान्य",
  dd_nav: "गीत समर्पण", dd_title: "गीत समर्पण", dd_sub: "किसी प्रिय को एक छोटे संदेश के साथ गीत भेंट करें।",
  dd_create: "एक समर्पण बनाएँ", dd_empty: "अभी कोई समर्पण नहीं — पहले बनें!",
  dd_to: "किसके लिए?", dd_from: "किसकी ओर से?", dd_message: "संदेश (वैकल्पिक)", dd_pick_song: "एक गीत चुनें",
  dd_send: "समर्पण भेजें", dd_share: "यह लिंक साझा करें", dd_copy: "लिंक कॉपी करें", dd_copied: "कॉपी हो गया",
  dd_play: "गीत सुनें", dd_for: "के लिए", dd_created: "समर्पण बन गया!", dd_open: "खोलें",
  dd_reveal: "अपना उपहार खोलने के लिए टैप करें", dd_featured: "विशेष समर्पण", feature: "विशेष करें",
  lt_nav: "साथ सुनें", lt_start: "साथ सुनें", lt_title: "साथ सुनें",
  lt_sub: "लिंक साझा करें और दूर होकर भी एक ही पल में साथ सुनें।",
  lt_pick: "सत्र शुरू करने के लिए एक गीत चुनें", lt_create: "सत्र शुरू करें", lt_share: "यह लिंक साझा करें",
  lt_copy: "लिंक कॉपी करें", lt_host: "आप मेज़बान हैं 🎧", lt_guest: "मेज़बान के साथ समकालिक",
  lt_tap_join: "शामिल होने के लिए यहाँ टैप करें", lt_waiting: "गीत की प्रतीक्षा...",
  kar_sing: "साथ गाएँ", kar_title: "कराओके",
  admin_title: "सिंधु कामरे · व्यवस्थापक", admin_login: "साइन इन करें", email: "ईमेल", password: "पासवर्ड", logout: "लॉग आउट",
  add_song: "नया गीत जोड़ें", songs_table: "गीत", tab_songs: "गीत", tab_subs: "भेजे गए",
  tab_ws: "कार्यशाला", tab_dd: "समर्पण", ws_remove: "हटाएँ", sub_pending: "समीक्षा लंबित",
  approve: "स्वीकृत करें", reject: "अस्वीकार करें", no_subs: "अभी कोई गीत नहीं भेजा गया।",
  pk_nav: "पोत कामरे", pk_title: "पोत कामरे — कहानियाँ और ऑडियोबुक",
  pk_sub: "शांत स्वर में सुनाई कहानियाँ, जातक कथाएँ और यादें — आँखों को आराम दें और सुनें।",
  pk_banner_sub: "आँखों को आराम दें और सुनें — कहानियाँ और ऑडियोबुक।",
  pk_empty: "अभी कोई ऑडियोबुक नहीं।", pk_chapters: "अध्याय", pk_chapter: "अध्याय",
  pk_listen: "सुनें", pk_resume: "फिर से शुरू करें", pk_by: "वाचक", pk_play_book: "शुरू से सुनें",
  fav_title: "आपके पसंदीदा", fav_filter: "पसंदीदा", fav_add: "पसंदीदा में जोड़ें", fav_remove: "पसंदीदा से हटाएँ",
  fav_empty: "अभी कोई पसंदीदा गीत नहीं। किसी गीत पर दिल दबाकर सहेजें।", fav_saved: "इस डिवाइस पर सहेजा गया",
  col_title: "संग्रह", col_sub: "भाव और विषय के अनुसार चुने गए एल्बम।",
  col_play_all: "सभी बजाएँ", col_songs: "गीत", col_open: "खोलें",
  sp_by: "प्रस्तुतकर्ता", tab_books: "ऑडियोबुक", tab_col: "संग्रह", tab_sponsor: "प्रायोजक",
  add_book: "एक ऑडियोबुक जोड़ें", add_chapter: "एक अध्याय जोड़ें",
  share: "साझा करें", wa_share: "WhatsApp पर साझा करें", link_copied: "लिंक कॉपी हो गया", pk_featured: "विशेष ऑडियोबुक",
  poya_today: "आज पोया दिवस है", poya_eve: "कल पोया दिवस है", poya_listen: "पोया दीप जलाएँ", poya_meheni: "मेहेणी शासन को नमन",
  meheni_title: "मेहेणी स्वर — महिलाओं के गीत", meheni_note: "भिक्खुणी शासन की स्थापना की स्मृति में, महिला कलाकारों और भिक्षुणियों को नमन।",
  st_nav: "कथा कामरे", st_title: "कथा कामरे — बच्चों के लिए कहानियाँ", st_sub: "दादा-दादी अपने नाती-पोतों को सुनाएँ — शांत स्वर में लोककथाएँ और सोने से पहले की कहानियाँ।", st_banner_sub: "नाती-पोतों को सुनाने के लिए लोककथाएँ और सोने की कहानियाँ।", st_empty: "अभी कोई कहानी नहीं जोड़ी गई।",
  rooms_title: "कक्ष", rooms_sub: "नियोक्स सिंधु कामरे के कक्षों में प्रवेश करें।",
  wg_nav: "वरिष्ठ गायक", wg_title: "वरिष्ठ गायक — हमारे बुज़ुर्गों की आवाज़ें", wg_sub: "वरिष्ठ कलाकारों की रिकॉर्डिंग — आदर और स्नेह के साथ।",
  bh_nav: "भावना कामरे", bh_title: "भावना कामरे — शांत मन", bh_sub: "ध्यान, श्वास और कोमल शांत ध्वनियाँ — विश्राम करें।",
  fam_title: "दूर बसे परिवार के लिए", voice_nav: "अपनी ही आवाज़ में", voice_title: "अपनी ही आवाज़ में — परिवार के लिए एक संदेश",
  rem_nav: "पुण्यानुमोदना", rem_title: "पुण्यानुमोदना — स्मरण", rem_sadhu: "दीप जलाकर पुण्य साझा करें — साधु!",
  wb_nav: "वाद बायला कामरे", wb_title: "वाद बायला कामरे — पद-दर-पद",
  wb_sub: "एक पद लिखें, बदले में एक चतुर तुकबंदी वाला पद पाएँ — मज़ेदार बायला जुगलबंदी।",
  wb_mode_ai: "ऐप के साथ", wb_mode_human: "दो खिलाड़ी", wb_you: "आप", wb_app: "ऐप",
  wb_p1: "खिलाड़ी 1", wb_p2: "खिलाड़ी 2", wb_turn: "बारी:",
  wb_input_hint: "अपना पद यहाँ लिखें...", wb_send: "पद भेजें",
  wb_thinking: "उत्तर पद रचा जा रहा है...", wb_read: "ज़ोर से पढ़ें", wb_stop_read: "रोकें",
  wb_empty: "पहला पद लिखकर जुगलबंदी शुरू करें.", wb_new: "नई जुगलबंदी",
  wb_error: "उत्तर पद नहीं बन सका. कृपया फिर से प्रयास करें.", wb_wrote: "पद:",
  music_credit_bg: "पृष्ठभूमि संगीत", music_credit_lic: "CC BY 4.0 के तहत लाइसेंस प्राप्त",
  invite_send: "परिवार और दोस्तों को बुलाएँ",
  poster_download: "पोस्टर डाउनलोड करें",
  invite_msg: "🪔 सिंधु कामरे — हमारे बुज़ुर्गों के लिए शांत पुराने गीत, कहानियाँ और ध्यान। मन को ताज़ा करने वाला, कोई लॉगिन नहीं, मुफ़्त। यहाँ सुनें:",
  listeners_joined: "लोग पहले से सुन रहे हैं",
  sotd_title: "आज का गीत", sotd_greet: "आज आपके लिए एक छोटा उपहार 🌸",
  sotd_g_morning: "सुप्रभात, दोस्त 🌅", sotd_g_afternoon: "नमस्कार, दोस्त ☀️", sotd_g_evening: "शुभ संध्या, दोस्त 🌇", sotd_g_night: "शुभ रात्रि, दोस्त 🌙",
};

// Telugu overlay — diaspora / South-Indian clone. Falls back to English where missing.
const teDict = {
  brand: "సింధు కామరే", brand_sub: "నియోక్స్", admin: "నిర్వాహకుడు",
  hero_title: "సింధు కామరే — శ్రీలంక మధురమైన పాత పాటలు",
  hero_sub: "ప్రశాంతమైన పాత పాటలు, వీణ, తబలా — దీపం వెలిగించినట్లు వినే సంగీతం.",
  play_all: "అన్నీ ప్లే చేయి", featured: "నేటి కొత్త పాటలు", featured_sub: "నేటి ప్రత్యేక పాటలు",
  full_list: "పూర్తి పాటల సేకరణ", full_list_sub: "పూర్తి సేకరణ",
  no_songs: "ఇంకా పాటలు జోడించలేదు.", loading: "లోడ్ అవుతోంది...",
  play: "ప్లే", pause: "ఆపు", prev: "మునుపటి పాట", next: "తదుపరి పాట", auto_next: "ఆటో-తదుపరి",
  tap_continue: "కొనసాగించడానికి ఇక్కడ నొక్కండి", now_playing: "ఇప్పుడు ప్లే అవుతోంది",
  sleep: "స్లీప్ టైమర్", sleep_off: "ఆఫ్", sleep_end: "పాట చివరిలో", sleep_min: "నిమి", sleep_on: "స్లీప్:",
  quiet_note: "మనసుకు హాయినిచ్చే · ట్రాకింగ్ లేదు · ప్రశాంత శ్రవణం",
  filters_all: "అన్నీ", filters_calm: "ప్రశాంత పాటలు", filters_veena: "వీణ", filters_tabla: "తబలా",
  back_room: "గదికి తిరిగి",
  submit_nav: "మీ పాట పంపండి", submit_title: "మీ రికార్డింగ్ పంచుకోండి",
  submit_sub: "కొత్త గాయకులు తమ రికార్డింగ్‌లు పంపవచ్చు. ముందుగా మీ ఇమెయిల్ ధృవీకరించండి.",
  submit_email_label: "మీ ఇమెయిల్", submit_send_code: "కోడ్ పంపు",
  submit_code_label: "ఇమెయిల్‌కు వచ్చిన కోడ్ నమోదు చేయండి", submit_verify: "ధృవీకరించు",
  submit_resend: "కోడ్ మళ్లీ పంపు", submit_change_email: "ఇమెయిల్ మార్చు", submit_form_title: "పాట వివరాలు",
  f_title_en: "పాట పేరు (ఇంగ్లీష్)", f_title_si: "పాట పేరు (సింహళ)", f_artist: "కళాకారుడు",
  f_singer_name: "మీ పేరు", f_contact: "ఫోన్ / సంప్రదింపు (ఐచ్ఛికం)", f_year: "సంవత్సరం (ఐచ్ఛికం)",
  f_tags: "ట్యాగ్‌లు (కామాతో వేరు చేయండి)", f_notes: "గమనికలు (ఐచ్ఛికం)",
  f_audio: "ఆడియో ఫైల్ (MP3)", f_cover: "కవర్ చిత్రం (ఐచ్ఛికం)",
  consent_label: "ఈ రికార్డింగ్‌పై హక్కు నాకు ఉందని, నియోక్స్ సింధు కామరేలో పంచుకోవడానికి అంగీకరిస్తున్నానని నిర్ధారిస్తున్నాను.",
  submit_btn: "పాట పంపు", submit_done_title: "ధన్యవాదాలు! మీ పాట అందింది.",
  submit_done_sub: "మా బృందం సమీక్షించి త్వరలో జోడిస్తుంది.", submit_another: "మరొకటి పంపు",
  ws_nav: "సృజన కార్యశాల", ws_title: "సృజన కార్యశాల",
  ws_sub: "గేయ రచయితలు పదాలు రాస్తారు · స్వరకర్తలు స్వరాలు జోడిస్తారు · గాయకులు పాడతారు. వాణిజ్యేతర సామాజిక భాగస్వామ్యం మాత్రమే.",
  ws_post: "పదాలు పోస్ట్ చేయి", ws_empty: "ఇంకా సృజనలు లేవు — మొదటివారు కండి!",
  ws_new_title: "కొత్త పదాల సృజన", ws_field_title: "శీర్షిక", ws_field_lyrics: "పదాలు",
  ws_field_author: "మీ పేరు", ws_field_tags: "ట్యాగ్‌లు (కామాతో)", ws_melodies: "స్వరాలు", ws_vocals: "గానాలు",
  ws_none_melody: "ఇంకా స్వరాలు లేవు.", ws_none_vocal: "ఇంకా గానాలు లేవు.",
  ws_add_melody: "ఒక స్వరం జోడించు", ws_sing: "పాడు / రికార్డ్ చేయి", ws_upload_take: "పూర్తి గానం అప్‌లోడ్ చేయి",
  ws_composer: "స్వరకర్త పేరు", ws_singer: "గాయకుని పేరు", ws_instrumental: "స్వరం (వాద్య ఆడియో)",
  ws_pick_melody: "పాడటానికి ఒక స్వరం ఎంచుకో", ws_record: "రికార్డింగ్ ప్రారంభించు", ws_stop: "ఆపు",
  ws_rerecord: "మళ్లీ రికార్డ్ చేయి", ws_balance: "గొంతు / స్వరం సమతుల్యం", ws_mixing: "మిక్స్ అవుతోంది...",
  ws_publish_take: "గానం ప్రచురించు", ws_open: "తెరువు", ws_by: "ద్వారా",
  recording_now: "రికార్డ్ అవుతోంది...", mic_denied: "మైక్రోఫోన్ అనుమతి నిరాకరించబడింది.",
  noncommercial_note: "వాణిజ్యేతర సామాజిక భాగస్వామ్యం మాత్రమే.", otp_verify_first: "సహకరించడానికి మీ ఇమెయిల్ ధృవీకరించండి",
  cancel: "రద్దు చేయి", post: "పోస్ట్ చేయి",
  eb_nav: "సాయంకాల ఆశీర్వాదం", eb_title: "సాయంకాల ఆశీర్వాదం", eb_sub: "సాయంత్రం అవుతుండగా, ఒక దీపం వెలిగించి, ప్రశాంత సంగీతంతో రోజును ముగించండి.",
  eb_light: "దీపం వెలిగించు", eb_not_now: "ఇప్పుడు కాదు", eb_settings: "సెట్టింగ్‌లు", eb_name: "మీ పేరు (ఐచ్ఛికం)",
  eb_tradition: "సంప్రదాయం", eb_time: "సాయంత్ర సమయం", eb_enable: "ప్రతి సాయంత్రం దీపం వెలిగించు", eb_save: "సేవ్ చేయి", eb_saved: "సేవ్ అయింది",
  eb_todays_lamp: "నేటి దీపం", trad_buddhist: "బౌద్ధ", trad_christian: "క్రైస్తవ", trad_hindu: "హిందూ", trad_none: "సాధారణ",
  dd_nav: "పాట అంకితం", dd_title: "పాట అంకితాలు", dd_sub: "ప్రియమైన వారికి చిన్న సందేశంతో పాటను బహుమతిగా ఇవ్వండి.",
  dd_create: "ఒక అంకితం సృష్టించు", dd_empty: "ఇంకా అంకితాలు లేవు — మొదటివారు కండి!",
  dd_to: "ఎవరికి?", dd_from: "ఎవరి నుండి?", dd_message: "సందేశం (ఐచ్ఛికం)", dd_pick_song: "ఒక పాట ఎంచుకో",
  dd_send: "అంకితం పంపు", dd_share: "ఈ లింక్ పంచుకో", dd_copy: "లింక్ కాపీ చేయి", dd_copied: "కాపీ అయింది",
  dd_play: "పాట విను", dd_for: "కోసం", dd_created: "అంకితం సృష్టించబడింది!", dd_open: "తెరువు",
  dd_reveal: "మీ బహుమతి తెరవడానికి నొక్కండి", dd_featured: "ప్రత్యేక అంకితం", feature: "ప్రత్యేకం చేయి",
  lt_nav: "కలిసి విను", lt_start: "కలిసి విందాం", lt_title: "కలిసి విను",
  lt_sub: "లింక్ పంచుకుని, దూరంగా ఉన్నా ఒకే క్షణంలో కలిసి వినండి.",
  lt_pick: "సెషన్ ప్రారంభించడానికి ఒక పాట ఎంచుకో", lt_create: "సెషన్ ప్రారంభించు", lt_share: "ఈ లింక్ పంచుకో",
  lt_copy: "లింక్ కాపీ చేయి", lt_host: "మీరు హోస్ట్ 🎧", lt_guest: "హోస్ట్‌తో సమకాలీనం",
  lt_tap_join: "చేరడానికి ఇక్కడ నొక్కండి", lt_waiting: "పాట కోసం వేచి...",
  kar_sing: "కలిసి పాడు", kar_title: "కరోకే",
  admin_title: "సింధు కామరే · నిర్వాహకుడు", admin_login: "సైన్ ఇన్", email: "ఇమెయిల్", password: "పాస్‌వర్డ్", logout: "లాగ్ అవుట్",
  add_song: "కొత్త పాట జోడించు", songs_table: "పాటలు", tab_songs: "పాటలు", tab_subs: "పంపినవి",
  tab_ws: "కార్యశాల", tab_dd: "అంకితాలు", ws_remove: "తొలగించు", sub_pending: "సమీక్ష పెండింగ్",
  approve: "ఆమోదించు", reject: "తిరస్కరించు", no_subs: "ఇంకా పాటలు పంపలేదు.",
  pk_nav: "పోత్ కామరే", pk_title: "పోత్ కామరే — కథలు & ఆడియో పుస్తకాలు",
  pk_sub: "ప్రశాంత స్వరంతో చెప్పే కథలు, జాతక కథలు, జ్ఞాపకాలు — కళ్లకు విశ్రాంతినిచ్చి వినండి.",
  pk_banner_sub: "కళ్లకు విశ్రాంతినిచ్చి వినండి — కథలు & ఆడియో పుస్తకాలు.",
  pk_empty: "ఇంకా ఆడియో పుస్తకాలు లేవు.", pk_chapters: "అధ్యాయాలు", pk_chapter: "అధ్యాయం",
  pk_listen: "విను", pk_resume: "మళ్లీ ప్రారంభించు", pk_by: "వివరించినవారు", pk_play_book: "మొదటి నుండి విను",
  fav_title: "మీ ఇష్టమైనవి", fav_filter: "ఇష్టమైనవి", fav_add: "ఇష్టమైనవాటికి జోడించు", fav_remove: "ఇష్టమైనవాటి నుండి తొలగించు",
  fav_empty: "ఇంకా ఇష్టమైన పాటలు లేవు. ఒక పాటపై హృదయం నొక్కి సేవ్ చేయండి.", fav_saved: "ఈ పరికరంలో సేవ్ అయింది",
  col_title: "సేకరణలు", col_sub: "భావం మరియు థీమ్ ప్రకారం ఎంచుకున్న ఆల్బమ్‌లు.",
  col_play_all: "అన్నీ ప్లే చేయి", col_songs: "పాటలు", col_open: "తెరువు",
  sp_by: "అందిస్తున్నవారు", tab_books: "ఆడియో పుస్తకాలు", tab_col: "సేకరణలు", tab_sponsor: "స్పాన్సర్",
  add_book: "ఒక ఆడియో పుస్తకం జోడించు", add_chapter: "ఒక అధ్యాయం జోడించు",
  share: "పంచుకో", wa_share: "WhatsApp లో పంచుకో", link_copied: "లింక్ కాపీ అయింది", pk_featured: "ప్రత్యేక ఆడియో పుస్తకం",
  poya_today: "నేడు పోయా దినం", poya_eve: "రేపు పోయా దినం", poya_listen: "పోయా దీపం వెలిగించు", poya_meheni: "మెహేణి శాసనానికి నమస్కారం",
  meheni_title: "మెహేణి స్వరాలు — మహిళల పాటలు", meheni_note: "భిక్షుణి శాసనం స్థాపనను స్మరిస్తూ, మహిళా కళాకారులకు మరియు సన్యాసినులకు నమస్కారం.",
  st_nav: "కథ కామరే", st_title: "కథ కామరే — పిల్లల కథలు", st_sub: "తాత-అమ్మమ్మలు మనవళ్లకు చెప్పడానికి, ప్రశాంత స్వరంతో జానపద కథలు, నిద్ర కథలు.", st_banner_sub: "మనవళ్లకు చెప్పడానికి జానపద కథలు, నిద్ర కథలు.", st_empty: "ఇంకా కథలు జోడించలేదు.",
  rooms_title: "గదులు", rooms_sub: "నియోక్స్ సింధు కామరే గదులలోకి ప్రవేశించండి.",
  wg_nav: "వృద్ధ గాయకులు", wg_title: "వృద్ధ గాయకులు — మన పెద్దల స్వరాలు", wg_sub: "వృద్ధ కళాకారుల రికార్డింగ్‌లు — గౌరవం మరియు ప్రేమతో.",
  bh_nav: "భావన కామరే", bh_title: "భావన కామరే — ప్రశాంత మనసు", bh_sub: "ధ్యానం, శ్వాస మరియు మృదువైన ప్రశాంత శబ్దాలు — విశ్రాంతి తీసుకోండి.",
  fam_title: "దూరంగా ఉన్న కుటుంబానికి", voice_nav: "మీ సొంత స్వరంలో", voice_title: "మీ సొంత స్వరంలో — కుటుంబానికి ఒక సందేశం",
  rem_nav: "పుణ్యానుమోదన", rem_title: "పుణ్యానుమోదన — స్మరణ", rem_sadhu: "దీపం వెలిగించి పుణ్యం పంచుకోండి — సాధు!",
  wb_nav: "వాద బాయిలా కామరే", wb_title: "వాద బాయిలా కామరే — పదానికి పదం",
  wb_sub: "ఒక పదం రాయండి, బదులుగా తెలివైన ప్రాస పదం పొందండి — సరదా బాయిలా పోటీ.",
  wb_mode_ai: "యాప్‌తో", wb_mode_human: "ఇద్దరు", wb_you: "మీరు", wb_app: "యాప్",
  wb_p1: "ఆటగాడు 1", wb_p2: "ఆటగాడు 2", wb_turn: "వంతు:",
  wb_input_hint: "మీ పదం ఇక్కడ రాయండి...", wb_send: "పదం పంపు",
  wb_thinking: "బదులు పదం సృష్టించబడుతోంది...", wb_read: "బిగ్గరగా చదువు", wb_stop_read: "ఆపు",
  wb_empty: "మొదటి పదం రాసి పోటీ ప్రారంభించండి.", wb_new: "కొత్త పోటీ",
  wb_error: "బదులు పదం సృష్టించలేకపోయాం. మళ్లీ ప్రయత్నించండి.", wb_wrote: "పదం:",
  music_credit_bg: "నేపథ్య సంగీతం", music_credit_lic: "CC BY 4.0 క్రింద లైసెన్స్ చేయబడింది",
  invite_send: "కుటుంబాన్ని, స్నేహితులను ఆహ్వానించండి",
  poster_download: "పోస్టర్ డౌన్‌లోడ్ చేయండి",
  invite_msg: "🪔 సింధు కామరే — మన పెద్దల కోసం ప్రశాంత పాత పాటలు, కథలు, ధ్యానం. మనసుకు హాయినిచ్చే, లాగిన్ లేదు, ఉచితం. ఇక్కడ వినండి:",
  listeners_joined: "మంది ఇప్పటికే వింటున్నారు",
  sotd_title: "నేటి పాట", sotd_greet: "ఈరోజు మీ కోసం ఒక చిన్న బహుమతి 🌸",
  sotd_g_morning: "శుభోదయం, మిత్రమా 🌅", sotd_g_afternoon: "శుభ మధ్యాహ్నం, మిత్రమా ☀️", sotd_g_evening: "శుభ సాయంత్రం, మిత్రమా 🌇", sotd_g_night: "శుభ రాత్రి, మిత్రమా 🌙",
};

// Bengali overlay — diaspora / East-Indian clone. Falls back to English where missing.
const bnDict = {
  brand: "সিন্ধু কামারে", brand_sub: "নিওক্স", admin: "প্রশাসক",
  hero_title: "সিন্ধু কামারে — শ্রীলঙ্কার মধুর পুরনো গান",
  hero_sub: "শান্ত পুরনো গান, বীণা ও তবলা — প্রদীপ জ্বালিয়ে শোনার মতো সঙ্গীত।",
  play_all: "সব বাজাও", featured: "আজকের নতুন গান", featured_sub: "আজকের বিশেষ গান",
  full_list: "সম্পূর্ণ গানের সংগ্রহ", full_list_sub: "সম্পূর্ণ সংগ্রহ",
  no_songs: "এখনও কোনো গান যোগ করা হয়নি।", loading: "লোড হচ্ছে...",
  play: "বাজাও", pause: "থামাও", prev: "আগের গান", next: "পরের গান", auto_next: "স্বয়ংক্রিয়-পরের",
  tap_continue: "চালিয়ে যেতে এখানে চাপুন", now_playing: "এখন বাজছে",
  sleep: "স্লিপ টাইমার", sleep_off: "বন্ধ", sleep_end: "গানের শেষে", sleep_min: "মিনিট", sleep_on: "স্লিপ:",
  quiet_note: "মন সতেজকারী · কোনো ট্র্যাকিং নেই · শান্ত শ্রবণ",
  filters_all: "সব", filters_calm: "শান্ত গান", filters_veena: "বীণা", filters_tabla: "তবলা",
  back_room: "কক্ষে ফিরুন",
  submit_nav: "আপনার গান পাঠান", submit_title: "আপনার রেকর্ডিং শেয়ার করুন",
  submit_sub: "নতুন শিল্পীরা তাদের রেকর্ডিং পাঠাতে পারেন। প্রথমে আপনার ইমেল যাচাই করুন।",
  submit_email_label: "আপনার ইমেল", submit_send_code: "কোড পাঠান",
  submit_code_label: "ইমেলে পাঠানো কোড লিখুন", submit_verify: "যাচাই করুন",
  submit_resend: "কোড আবার পাঠান", submit_change_email: "ইমেল পরিবর্তন করুন", submit_form_title: "গানের বিবরণ",
  f_title_en: "গানের শিরোনাম (ইংরেজি)", f_title_si: "গানের শিরোনাম (সিংহল)", f_artist: "শিল্পী",
  f_singer_name: "আপনার নাম", f_contact: "ফোন / যোগাযোগ (ঐচ্ছিক)", f_year: "সাল (ঐচ্ছিক)",
  f_tags: "ট্যাগ (কমা দিয়ে আলাদা করুন)", f_notes: "মন্তব্য (ঐচ্ছিক)",
  f_audio: "অডিও ফাইল (MP3)", f_cover: "কভার ছবি (ঐচ্ছিক)",
  consent_label: "আমি নিশ্চিত করছি যে এই রেকর্ডিংয়ের অধিকার আমার আছে এবং নিওক্স সিন্ধু কামারেতে শেয়ার করার সম্মতি দিচ্ছি।",
  submit_btn: "গান পাঠান", submit_done_title: "ধন্যবাদ! আপনার গান পাওয়া গেছে।",
  submit_done_sub: "আমাদের দল পর্যালোচনা করে শীঘ্রই যোগ করবে।", submit_another: "আরেকটি পাঠান",
  ws_nav: "সৃষ্টি কর্মশালা", ws_title: "সৃষ্টি কর্মশালা",
  ws_sub: "গীতিকাররা কথা লেখেন · সুরকাররা সুর যোগ করেন · শিল্পীরা গান। শুধুমাত্র অবাণিজ্যিক সামাজিক ভাগাভাগি।",
  ws_post: "কথা পোস্ট করুন", ws_empty: "এখনও কোনো সৃষ্টি নেই — প্রথম হোন!",
  ws_new_title: "নতুন কথার সৃষ্টি", ws_field_title: "শিরোনাম", ws_field_lyrics: "কথা",
  ws_field_author: "আপনার নাম", ws_field_tags: "ট্যাগ (কমা দিয়ে)", ws_melodies: "সুর", ws_vocals: "কণ্ঠ",
  ws_none_melody: "এখনও কোনো সুর নেই।", ws_none_vocal: "এখনও কোনো কণ্ঠ নেই।",
  ws_add_melody: "একটি সুর যোগ করুন", ws_sing: "গান / রেকর্ড করুন", ws_upload_take: "সম্পূর্ণ গান আপলোড করুন",
  ws_composer: "সুরকারের নাম", ws_singer: "শিল্পীর নাম", ws_instrumental: "সুর (বাদ্য অডিও)",
  ws_pick_melody: "গাইতে একটি সুর বেছে নিন", ws_record: "রেকর্ডিং শুরু করুন", ws_stop: "থামান",
  ws_rerecord: "আবার রেকর্ড করুন", ws_balance: "কণ্ঠ / সুর ভারসাম্য", ws_mixing: "মিশ্রণ হচ্ছে...",
  ws_publish_take: "কণ্ঠ প্রকাশ করুন", ws_open: "খুলুন", ws_by: "দ্বারা",
  recording_now: "রেকর্ড হচ্ছে...", mic_denied: "মাইক্রোফোনের অনুমতি প্রত্যাখ্যাত।",
  noncommercial_note: "শুধুমাত্র অবাণিজ্যিক সামাজিক ভাগাভাগি।", otp_verify_first: "অবদান রাখতে আপনার ইমেল যাচাই করুন",
  cancel: "বাতিল করুন", post: "পোস্ট করুন",
  eb_nav: "সন্ধ্যা আশীর্বাদ", eb_title: "সন্ধ্যা আশীর্বাদ", eb_sub: "সন্ধ্যা নামলে, একটি প্রদীপ জ্বালান এবং শান্ত সঙ্গীতে দিন শেষ করুন।",
  eb_light: "প্রদীপ জ্বালান", eb_not_now: "এখন নয়", eb_settings: "সেটিংস", eb_name: "আপনার নাম (ঐচ্ছিক)",
  eb_tradition: "ঐতিহ্য", eb_time: "সন্ধ্যার সময়", eb_enable: "প্রতি সন্ধ্যায় প্রদীপ জ্বালান", eb_save: "সংরক্ষণ করুন", eb_saved: "সংরক্ষিত",
  eb_todays_lamp: "আজকের প্রদীপ", trad_buddhist: "বৌদ্ধ", trad_christian: "খ্রিস্টান", trad_hindu: "হিন্দু", trad_none: "সাধারণ",
  dd_nav: "গান উৎসর্গ", dd_title: "গান উৎসর্গ", dd_sub: "প্রিয়জনকে একটি ছোট বার্তাসহ গান উপহার দিন।",
  dd_create: "একটি উৎসর্গ তৈরি করুন", dd_empty: "এখনও কোনো উৎসর্গ নেই — প্রথম হোন!",
  dd_to: "কার জন্য?", dd_from: "কার কাছ থেকে?", dd_message: "বার্তা (ঐচ্ছিক)", dd_pick_song: "একটি গান বেছে নিন",
  dd_send: "উৎসর্গ পাঠান", dd_share: "এই লিঙ্ক শেয়ার করুন", dd_copy: "লিঙ্ক কপি করুন", dd_copied: "কপি হয়েছে",
  dd_play: "গান শুনুন", dd_for: "জন্য", dd_created: "উৎসর্গ তৈরি হয়েছে!", dd_open: "খুলুন",
  dd_reveal: "আপনার উপহার খুলতে চাপুন", dd_featured: "বিশেষ উৎসর্গ", feature: "বিশেষ করুন",
  lt_nav: "একসাথে শুনুন", lt_start: "একসাথে শুনি", lt_title: "একসাথে শুনুন",
  lt_sub: "লিঙ্ক শেয়ার করুন এবং দূরে থেকেও একই মুহূর্তে একসাথে শুনুন।",
  lt_pick: "সেশন শুরু করতে একটি গান বেছে নিন", lt_create: "সেশন শুরু করুন", lt_share: "এই লিঙ্ক শেয়ার করুন",
  lt_copy: "লিঙ্ক কপি করুন", lt_host: "আপনি হোস্ট 🎧", lt_guest: "হোস্টের সাথে সমকালীন",
  lt_tap_join: "যোগ দিতে এখানে চাপুন", lt_waiting: "গানের অপেক্ষায়...",
  kar_sing: "সাথে গান", kar_title: "কারাওকে",
  admin_title: "সিন্ধু কামারে · প্রশাসক", admin_login: "সাইন ইন", email: "ইমেল", password: "পাসওয়ার্ড", logout: "লগ আউট",
  add_song: "নতুন গান যোগ করুন", songs_table: "গান", tab_songs: "গান", tab_subs: "পাঠানো",
  tab_ws: "কর্মশালা", tab_dd: "উৎসর্গ", ws_remove: "সরান", sub_pending: "পর্যালোচনা মুলতুবি",
  approve: "অনুমোদন করুন", reject: "প্রত্যাখ্যান করুন", no_subs: "এখনও কোনো গান পাঠানো হয়নি।",
  pk_nav: "পোত কামারে", pk_title: "পোত কামারে — গল্প ও অডিওবুক",
  pk_sub: "শান্ত কণ্ঠে বলা গল্প, জাতক কাহিনী ও স্মৃতি — চোখ বিশ্রাম দিয়ে শুনুন।",
  pk_banner_sub: "চোখ বিশ্রাম দিয়ে শুনুন — গল্প ও অডিওবুক।",
  pk_empty: "এখনও কোনো অডিওবুক নেই।", pk_chapters: "অধ্যায়", pk_chapter: "অধ্যায়",
  pk_listen: "শুনুন", pk_resume: "আবার শুরু করুন", pk_by: "বর্ণনাকারী", pk_play_book: "শুরু থেকে শুনুন",
  fav_title: "আপনার প্রিয়", fav_filter: "প্রিয়", fav_add: "প্রিয়তে যোগ করুন", fav_remove: "প্রিয় থেকে সরান",
  fav_empty: "এখনও কোনো প্রিয় গান নেই। একটি গানে হৃদয় চেপে সংরক্ষণ করুন।", fav_saved: "এই ডিভাইসে সংরক্ষিত",
  col_title: "সংগ্রহ", col_sub: "মেজাজ ও থিম অনুযায়ী বাছাই করা অ্যালবাম।",
  col_play_all: "সব বাজাও", col_songs: "গান", col_open: "খুলুন",
  sp_by: "উপস্থাপনায়", tab_books: "অডিওবুক", tab_col: "সংগ্রহ", tab_sponsor: "স্পনসর",
  add_book: "একটি অডিওবুক যোগ করুন", add_chapter: "একটি অধ্যায় যোগ করুন",
  share: "শেয়ার করুন", wa_share: "WhatsApp-এ শেয়ার করুন", link_copied: "লিঙ্ক কপি হয়েছে", pk_featured: "বিশেষ অডিওবুক",
  poya_today: "আজ পোয়া দিবস", poya_eve: "আগামীকাল পোয়া দিবস", poya_listen: "পোয়া প্রদীপ জ্বালান", poya_meheni: "মেহেণি শাসনকে প্রণাম",
  meheni_title: "মেহেণি কণ্ঠ — নারীদের গান", meheni_note: "ভিক্ষুণী শাসন প্রতিষ্ঠার স্মরণে, নারী শিল্পী ও সন্ন্যাসিনীদের প্রণাম।",
  st_nav: "কথা কামারে", st_title: "কথা কামারে — শিশুদের গল্প", st_sub: "দাদু-দিদিমারা নাতি-নাতনিদের শোনাতে, শান্ত কণ্ঠে লোককথা ও ঘুমপাড়ানি গল্প।", st_banner_sub: "নাতি-নাতনিদের শোনাতে লোককথা ও ঘুমপাড়ানি গল্প।", st_empty: "এখনও কোনো গল্প যোগ করা হয়নি।",
  rooms_title: "কক্ষ", rooms_sub: "নিওক্স সিন্ধু কামারের কক্ষে প্রবেশ করুন।",
  wg_nav: "প্রবীণ শিল্পী", wg_title: "প্রবীণ শিল্পী — আমাদের বড়দের কণ্ঠ", wg_sub: "প্রবীণ শিল্পীদের রেকর্ডিং — শ্রদ্ধা ও ভালোবাসায়।",
  bh_nav: "ভাবনা কামারে", bh_title: "ভাবনা কামারে — শান্ত মন", bh_sub: "ধ্যান, শ্বাস ও কোমল শান্ত শব্দ — বিশ্রাম নিন।",
  fam_title: "দূরের পরিবারের জন্য", voice_nav: "আপনার নিজের কণ্ঠে", voice_title: "আপনার নিজের কণ্ঠে — পরিবারের জন্য একটি বার্তা",
  rem_nav: "পুণ্যানুমোদনা", rem_title: "পুণ্যানুমোদনা — স্মরণ", rem_sadhu: "প্রদীপ জ্বালিয়ে পুণ্য ভাগ করুন — সাধু!",
  wb_nav: "বাদ বায়লা কামারে", wb_title: "বাদ বায়লা কামারে — পদে পদে",
  wb_sub: "একটি পদ লিখুন, বিনিময়ে একটি চতুর ছন্দময় পদ পান — মজার বায়লা দ্বৈরথ।",
  wb_mode_ai: "অ্যাপের সাথে", wb_mode_human: "দুজন", wb_you: "আপনি", wb_app: "অ্যাপ",
  wb_p1: "খেলোয়াড় ১", wb_p2: "খেলোয়াড় ২", wb_turn: "পালা:",
  wb_input_hint: "আপনার পদ এখানে লিখুন...", wb_send: "পদ পাঠান",
  wb_thinking: "উত্তর পদ রচিত হচ্ছে...", wb_read: "জোরে পড়ুন", wb_stop_read: "থামান",
  wb_empty: "প্রথম পদ লিখে দ্বৈরথ শুরু করুন।", wb_new: "নতুন দ্বৈরথ",
  wb_error: "উত্তর পদ তৈরি করা যায়নি। আবার চেষ্টা করুন।", wb_wrote: "পদ:",
  music_credit_bg: "আবহ সঙ্গীত", music_credit_lic: "CC BY 4.0 লাইসেন্সের অধীনে",
  invite_send: "পরিবার ও বন্ধুদের আমন্ত্রণ জানান",
  poster_download: "পোস্টার ডাউনলোড করুন",
  invite_msg: "🪔 সিন্ধু কামারে — আমাদের বড়দের জন্য শান্ত পুরনো গান, গল্প ও ধ্যান। মন সতেজকারী, লগইন নেই, বিনামূল্যে। এখানে শুনুন:",
  listeners_joined: "জন ইতিমধ্যে শুনছেন",
  sotd_title: "আজকের গান", sotd_greet: "আজ আপনার জন্য ছোট্ট উপহার 🌸",
  sotd_g_morning: "শুভ সকাল, বন্ধু 🌅", sotd_g_afternoon: "শুভ অপরাহ্ন, বন্ধু ☀️", sotd_g_evening: "শুভ সন্ধ্যা, বন্ধু 🌇", sotd_g_night: "শুভ রাত্রি, বন্ধু 🌙",
};

const OVERLAYS = { ta: taDict, hi: hiDict, te: teDict, bn: bnDict };

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

export function LangProvider({ children }) {
  // Languages live at launch. Others (en, hi, te, bn) are fully built but locked
  // until a regional partner + licensing is in place — add them back here to re-open.
  const ACTIVE_LANGS = ["si", "ta", "en"];
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("sk_lang");
    return ACTIVE_LANGS.includes(saved) ? saved : "si";
  });
  const [theme, setTheme] = useState(() => localStorage.getItem("sk_theme") || "light");

  useEffect(() => {
    localStorage.setItem("sk_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("sk_theme", theme);
    document.documentElement.dataset.theme = theme === "dark" ? "dark" : "light";
  }, [theme]);

  const t = (key) => {
    if (OVERLAYS[lang]) return OVERLAYS[lang][key] || (dict[key] ? dict[key].en : key);
    return dict[key] ? dict[key][lang] : key;
  };
  const other = (key) => {
    const alt = lang === "si" ? "en" : "si";
    if (OVERLAYS[lang]) return dict[key] ? dict[key].en : "";
    return dict[key] ? dict[key][alt] : "";
  };
  // Script-appropriate display font class for a given language.
  const fontClass = (l = lang) => (l === "ta" ? "font-ta" : l === "hi" ? "font-hi" : l === "te" ? "font-te" : l === "bn" ? "font-bn" : l === "si" ? "font-si" : "font-en");
  const ORDER = ACTIVE_LANGS;
  const NEXT_LABEL = { si: "த", ta: "EN", en: "සිං", hi: "సిం", te: "সিং", bn: "සිං" };
  const toggleLang = () => setLang((l) => ORDER[(ORDER.indexOf(l) + 1) % ORDER.length]);
  const nextLangLabel = NEXT_LABEL[lang] || "த";
  const toggleTheme = () => setTheme((th) => (th === "dark" ? "light" : "dark"));

  return (
    <LangContext.Provider value={{ lang, t, other, fontClass, nextLangLabel, toggleLang, theme, toggleTheme }}>
      {children}
    </LangContext.Provider>
  );
}
